module.exports = __webpack_public_path__ + "static/media/global-group--resized.2d6da63d.jpg";